<template>
  <BaseVueJsModal
    v-bind="{
      ...$attrs,
      ...getVueJsModalAttrs,
    }"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <div :style="style.container">
      <slot name="top" />
      <TextRegular :style="style.text">
        <slot />
      </TextRegular>
      <div :style="style.actionContainer">
        <ButtonSecondary
          @click="$emit('click-secondary')"
          :style="style.button"
        >
          <slot name="secondary-button">
            {{ secondaryActionLabel }}
          </slot>
        </ButtonSecondary>
        <ButtonPrimary
          @click="$emit('click-primary')"
          :style="style.button"
        >
          <slot name="primary-button">
            {{ primaryActionLabel }}
          </slot>
        </ButtonPrimary>
      </div>
      <slot name="bottom" />
    </div>
  </BaseVueJsModal>
</template>

<script>
  import BaseVueJsModal from '@base/v2/base-vue-js-modal'
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ModalConfirmationDialog',
    inheritAttrs: false,
    components: {
      BaseVueJsModal,
      ButtonPrimary,
      ButtonSecondary,
      TextRegular,
    },
    props: {
      primaryActionLabel: {
        type: String,
        required: false,
        default: 'OK',
      },
      secondaryActionLabel: {
        type: String,
        required: false,
        default: 'Cancel',
      },
    },
    data: function () {
      return {
        style: {
          actionContainer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          button: {
            margin: `${Layout.space.md} ${Layout.space.lg}`,
            minWidth: '80px',
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
          },
          text: {
            margin: `${Layout.space.md} 0`,
            overflowWrap: 'break-word',
          },
        },
        styleConfig: {
          container: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            padding: Layout.space.lg,
            width: '100%',
          },
          modal: {
            borderRadius: Layout.space.sm,
            boxShadow: `0 ${Layout.space.xs} ${Layout.space.md} rgba(0, 0, 0, 0.2)`,
            maxWidth: '90%',
            minHeight: '100px',
          },
        },
      }
    },
    created: function () {
      Object.assign(
        this.styleConfig.modal,
        {
          backgroundColor: this.color.light1(),
          border: `solid ${this.color.dark5()}`,
          borderWidth: '1px',
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getVueJsModalAttrs: function () {
        return {
          adaptive: true,
          draggable: false,
          resizable: false,
          scrollable: false,
          height: 'auto',
          maxWidth: 400,
          width: '90%',
        };
      },
    },
  };
</script>
